import { Variants } from "framer-motion";
import { useMemo } from "react";

export type NeededMeasurements = Pick<
  DOMRect,
  "left" | "top" | "width" | "height"
>;

export function useParentVariants(measurements: NeededMeasurements): Variants {
  function clipPathOpened(measurements: NeededMeasurements) {
    return `circle(200% at ${measurements.left + measurements.width / 2}px ${
      measurements.top + measurements.height / 2
    }px)`;
  }

  function clipPathClosed(measurements: NeededMeasurements) {
    return `circle(0% at ${measurements.left + measurements.width / 2}px ${
      measurements.top + measurements.height / 2
    }px)`;
  }

  return useMemo(
    () => ({
      closed: {
        clipPath: clipPathClosed(measurements),
        transition: {
          duration: 0.5,
          delayChildren: -0.2,
          staggerChildren: 0.1,
          staggerDirection: -1,
        },
        transitionEnd: {
          display: "none",
        },
      },
      open: {
        transition: {
          duration: 1,
          beforeChildren: true,
          delayChildren: 0.3,
          staggerChildren: 0.2,
        },
        display: "block",
        clipPath: clipPathOpened(measurements),
      },
    }),
    [measurements]
  );
}

export const childrenVariants: Variants = {
  closed: { opacity: 0, y: -1, transition: { duration: 0.3 } },
  open: { opacity: 1, y: 0, transition: { duration: 0.3 } },
};
